import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { setLocationTree, clearLocationTree, selectedLocations, setCustomerLocationTree, setSenderLocations, setLocationList, setReceiverLocations, setExternalLocations, setSenderLocationsTree, setCustomerLocationList } from './location-tree.actions';

export interface LocationState {
    locationTree: any | null;
    locationList: any | null;
    externalLocations: any | null;
    receiverLocations: any | null;
    senderLocationTree: any | null;
    senderLocations: any | null;
    customerLocationTree: any | null;
    customerLocationList: any | null;
    selectedLocations: number[] | null;
}

export const initialState: LocationState = {
    locationTree: null,
    locationList: null,
    externalLocations: null,
    receiverLocations: null,
    senderLocationTree: null,
    senderLocations: null,
    customerLocationTree: null,
    customerLocationList: null,
    selectedLocations: null,
};

export const locationFeature = createFeature({
    name: 'location',
    reducer: createReducer(
        initialState,
        on(setLocationTree, (state, { locationTree }) => ({ ...state, locationTree: locationTree })),
        on(setLocationList, (state, { locationList }) => ({ ...state, locationList: locationList })),
        on(setExternalLocations, (state, { externalLocations }) => ({ ...state, externalLocations: externalLocations })),
        on(setReceiverLocations, (state, { receiverLocations }) => ({ ...state, receiverLocations: receiverLocations })),
        on(setSenderLocationsTree, (state, { senderLocationTree }) => ({ ...state, senderLocationTree: senderLocationTree })), // By customer
        on(setSenderLocations, (state, { senderLocations }) => ({ ...state, senderLocations: senderLocations })), // By customer
        on(setCustomerLocationTree, (state, { customerLocationTree }) => ({ ...state, customerLocationTree: customerLocationTree })),
        on(setCustomerLocationList, (state, { customerLocationList }) => ({ ...state, customerLocationList: customerLocationList })),
        on(selectedLocations, (state, { selectedLocations }) => ({ ...state, selectedLocations: selectedLocations })),
        on(clearLocationTree, () => ({ ...initialState })),
    ),
});

export const { name, reducer, selectLocationState } = locationFeature;

export const getLocationTree = createSelector(selectLocationState, (state) => state.locationTree);
export const getLocationList = createSelector(selectLocationState, (state) => state.locationList);

export const getCustomerLocationTree = createSelector(selectLocationState, (state) => state.customerLocationTree);
export const getCustomerLocationList = createSelector(selectLocationState, (state) => state.customerLocationList);

export const selectLocation = createSelector(selectLocationState, (state) => state.selectedLocations);

export const getSenderLocations = createSelector(selectLocationState, (state) => state.senderLocations);
export const getSenderLocationsTree = createSelector(selectLocationState, (state) => state.senderLocationTree);

export const getReceiverLocations = createSelector(selectLocationState, (state) => state.receiverLocations);
export const getExternalLocations = createSelector(selectLocationState, (state) => state.externalLocations);